<template>
	<div class="template-wrapper">
		<h2 class="page-title">{{ $t("huodonglist") }}</h2>
		<el-divider></el-divider>
		<el-button @click="dialogVisible = true" v-if="coupon_edit === '1'">{{ $t('addyhqTemplate') }}</el-button>

		<template v-if="coupon_read === '1'">
			<br />
			<br />
			<el-form ref="storeform" :model="storeform">
				<el-form-item :label="$t('selectStore')">
					<template>
						<div class="" style="display: flex">
							<el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
								<el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
								<el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
									:value="item.storeid"></el-option>
							</el-select>
						</div>
					</template>
				</el-form-item>
			</el-form>
		</template>

		<!--<span>優惠券數量：{{user.yhqnum}} </span>-->
		<!--        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" v-for="item in tab" :key="item.id"></el-tab-pane>
        </el-tabs> -->

		<template v-if="coupon_read === '1'">
			<el-table :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" stripe
				@sort-change="sortChange" style="width: 100%">


				<el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="180">
				</el-table-column>

				<el-table-column prop="title" :label="$t('huodongTitle')" sortable="custom" width="">
				</el-table-column>

				<el-table-column prop="maxnum" :label="$t('huodongMaxnum')" sortable="custom" width="150">
				</el-table-column>

				<el-table-column prop="nownum" :label="$t('canjianum')" sortable="custom" width="150">
				</el-table-column>

				<el-table-column prop="tuijian" :label="$t('huodongTuijian')" sortable="custom" width="">
					<template slot-scope="scope">
						<div>{{ decodeString(scope.row.tuijian) }} </div>
					</template>
				</el-table-column>


				<el-table-column prop="buyurl" :label="$t('huodongJiangpin')" sortable="custom" width="">
                    <template slot-scope="scope">
						<div>{{ decodeString(scope.row.buyurl) }} </div>
					</template>
				</el-table-column>

				<el-table-column prop="operation" :label="$t('adminset')" align="center" width="300">
					<template slot-scope="scope">
						<div class="operationVid">
							<el-button @click="edititem(scope.row)" v-if="coupon_edit === '1'">{{ $t("edit") }}</el-button>
                            <el-button @click="usagerecord(scope.row)">{{ $t("usageRecord") }}</el-button>
							<el-button @click="delitem(scope.row.id)" v-if="coupon_edit === '1'">{{ $t("delete") }}</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination flex-center">
				<span class="el-pagination__total">{{ $t("total") }} {{ tableData.length }} {{ $t("items") }}</span>
				<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-size="pageSize" layout="prev,pager,next" :total="tableData.length"></el-pagination>
			</div>
		</template>
		<template v-if="coupon_read === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>

		<!-- add -->
		<el-dialog :title="$t('addyhqTemplate')" :visible.sync="dialogVisible"
			:width="$store.state.isMobile ? '90%' : '556px'" :before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="form">


					<el-form-item :label="$t('storeList')">
						<el-select v-model="form.storeid" placeholder="" @change="changeStoreid">
							<el-option v-for="item in storelist" :label="item.name" :value="item.storeid"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item :label="$t('huodongTitle')">
						<el-input v-model="form.title"></el-input>
					</el-form-item>

					<el-form-item :label="$t('huodongMaxnum')">
						<el-input v-model="form.maxnum"></el-input>
					</el-form-item>
					<!--
				<el-form-item :label="$t('huodongTargetnum')">
                       
					 <el-input v-model="form.targetnum"></el-input>
                    </el-form-item>-->

					<!--
                    <el-form-item    :label="$t('templateid')">
                        <el-input v-model="form.templateid" type="textarea" :rows="1"></el-input>
                    </el-form-item>-->

					<!--
					<el-form-item    :label="$t('huodongNext')">
                        <!--<el-input v-model="form.next" type="textarea" :rows="1"></el-input>-->
					<!--
						<el-select v-model="form.next" placeholder="">
							<el-option v-for="item in huodonglist" :label="item.title" :value="item.id"></el-option>
							<el-option label="最後一個" value="0"></el-option>
							<el-option label="沒有" value="-1"></el-option>
						</el-select>
                    </el-form-item>-->

					<!--
					<el-form-item    :label="$t('imgurl')">
                        <el-input v-model="form.imgurl" type="textarea" :rows="1"></el-input>
                    </el-form-item>-->

					<el-form-item :label="$t('uploadImage')">
						<a href="#" @click="dialogExampleVisible = true">{{ $t("couponStyleExample") }}</a>
						<el-input v-model="form.imgurl"></el-input>
						<el-upload :limit="1" ref="elUpload" action="" list-type="picture-card" :auto-upload="true"
							:http-request="uploadSectionFile" :on-remove="handleRemove" accept=".png">
							<i slot="default" class="el-icon-plus" />
							<div slot="file" slot-scope="{file}">
								<el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
								<span class="el-upload-list__item-actions">
									<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
										<i class="el-icon-zoom-in" />
									</span>
									<span v-if="!disabled" class="el-upload-list__item-delete"
										@click="handleDownload(file)">
										<i class="el-icon-download" />
									</span>
									<span v-if="!disabled" class="el-upload-list__item-delete"
										@click="handleRemove(file)">
										<i class="el-icon-delete" />
									</span>
								</span>
							</div>
						</el-upload>

						<!-- <el-image-viewer :z-index="2002" v-if="showViewer" :on-close="closeViewer" :url-list="[dialogImageUrl]"/> -->



					</el-form-item>

					<el-form-item :label="$t('qrx')">
						<el-input v-model="form.qrx" :rows="1"></el-input>
					</el-form-item>

					<el-form-item :label="$t('qry')">
						<el-input v-model="form.qry" :rows="1"></el-input>
					</el-form-item>
					<el-form-item :label="$t('qrsize')">
						<el-select v-model="form.qrsize" placeholder="">
							<el-option :key="3" label="93x93" value="3"></el-option>
							<el-option :key="4" label="124x124" value="4"></el-option>
							<el-option :key="5" label="155x155" value="5"></el-option>
							<el-option :key="6" label="186x186" value="6"></el-option>
							<el-option :key="7" label="217x217" value="7"></el-option>
							<el-option :key="8" label="248x248" value="8"></el-option>
							<el-option :key="9" label="279x279" value="9"></el-option>
							<el-option :key="10" label="310x310" value="10"></el-option>
							<el-option :key="11" label="341x341" value="11"></el-option>
							<el-option :key="12" label="372x372" value="12"></el-option>
							<el-option :key="13" label="403x403" value="13"></el-option>
							<el-option :key="14" label="434x434" value="14"></el-option>
							<el-option :key="15" label="465x465" value="15"></el-option>
							<el-option :key="16" label="496x496" value="16"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item :label="$t('huodongTuijian')">
						<el-input v-model="form.tuijian" type="textarea" :rows="5">
						</el-input>
					</el-form-item>

					<el-form-item :label="$t('huodongJiangpin')">
						<el-input v-model="form.buyurl" type="textarea" :rows="2"></el-input>
					</el-form-item>

                    <el-form-item :label="$t('couponLimitText1')">
						<el-input v-model="form.couponLimitText1" type="textarea" :rows="2"></el-input>
					</el-form-item>

                    <el-form-item :label="$t('couponLimitText2')">
						<el-input v-model="form.couponLimitText2" type="textarea" :rows="2"></el-input>
					</el-form-item>

                    <el-form-item :label="$t('couponLimitText3')">
						<el-input v-model="form.couponLimitText3" type="textarea" :rows="2"></el-input>
					</el-form-item>

                    <el-form-item :label="$t('isEnable')">
						<el-select v-model="form.isEnable" placeholder="">
							<el-option :label="$t('yes')" value="1"></el-option>
							<el-option :label="$t('no')" value="0"></el-option>

						</el-select>
					</el-form-item>



					<!-- 		  
                    <el-form-item v-if="form.type == 2">
                        <img width="100%" :src="form.pic" alt="">
                        <el-upload
                            action="https://jsonplaceholder.typicode.com/posts/"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove">
                             <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item> -->
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="sure">{{ $t('Sure') }}</el-button>
				<!-- <el-button v-if="form.type != 1"  type="primary" @click="submitImportForm">{{$t('Sure')}}{{form.type}}</el-button> -->
			</span>
		</el-dialog>


		<!-- example -->
		<el-dialog :title="$t('couponStyleExample')" :visible.sync="dialogExampleVisible"
			:width="$store.state.isMobile ? '90%' : '656px'" :before-close="handleClose">
			<div class="add-template">
				<el-image style="width: 600px; height: 600px" :src="require(`@/assets/images/example.jpeg`)"
					:fit="fit" />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogExampleVisible = false">{{ $t('Sure') }}</el-button>
			</span>
		</el-dialog>


        <!-- view usage -->
        <el-dialog :title="$t('usageRecord')" :visible.sync="dialogUsageVisible"
        :width="$store.state.isMobile ? '90%' : '856px'" :before-close="handleUsageClose" class="view-dialog">
            <h4>{{ $t('usageRecordAmount1') }}: {{ usageRecordAmount1 }}</h4>
            <h4>{{ $t('usageRecordAmount2') }}: {{ usageRecordAmount2 }}</h4>
            <div class="add-template">

                    <el-table :data="usageData.slice((usageDataCurrentPage - 1) * usageDataPageSize, usageDataCurrentPage * usageDataPageSize)
                        " stripe style="width: 100%">
                        <el-table-column prop="name" :label="$t('nickname')" sortable="custom">
                        </el-table-column>
                        <el-table-column prop="whatsapp" :label="$t('phoneNumber')" sortable="custom">
                        </el-table-column>
                        <el-table-column prop="addtime" :label="$t('usageRecordtime1')" sortable="custom">
                            <template slot-scope="scope">
                                <div>{{ scope.row.addtime | formatDate }} </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="usetime" :label="$t('usageRecordtime2')" sortable="custom">
                            <template slot-scope="scope" v-if="scope.row.status === '已使用'">
                                <div>{{ scope.row.usetime | formatDate }} </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" :label="$t('status')" sortable="custom">
                            <template slot-scope="scope">
                                <div v-if="scope.row.status === '已领取'">{{ $t('usageRecordStatus1') }} </div>
                                <div v-if="scope.row.status === '已使用'">{{ $t('usageRecordStatus2') }} </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination flex-center">
                        <span class="el-pagination__total">{{ $t("total") }} {{ usageData.length }} {{ $t("items") }}</span>
                        <el-pagination background @current-change="handleUsageDataCurrentChange"
                        :current-page="usageDataCurrentPage" :page-size="usageDataPageSize" layout="prev,pager,next"
                        :total="usageData.length"></el-pagination>
                    </div>
 
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogUsageVisible = false">{{ $t("Cancel") }}</el-button>
                <el-button type="primary" @click="dialogUsageVisible = false">{{
                $t("Sure")
                }}</el-button>
            </span>
        </el-dialog>

	</div>
</template>
<script>
import { formatDate } from '../../assets/date.js'
import axios from 'axios'
import { tongyong, addHuoDong, imageUpload, getStore, getCouponUsage } from '@/api'
export default {
	data() {
		return {
			coupon_read: '0',
			coupon_edit: '0',
			exportcsv: '0',
			qyid: '',
            storeid: '',
			user: {},
			fileList: [], pagelist: [],
			currentPage: 1,  // 当前页码
			pageSize: 10,  // 每页显示的行数
			activeName: '0',
			dialogVisible: false,
			dialogExampleVisible: false,
            dialogUsageVisible: false,
			tab: [
				{ label: this.$t('underApproval'), id: '0' },
				{ label: this.$t('passed'), id: '1' }
			],
			tableData: [],
			tableData1: [

				{ timer: '2018-01-01', name: '测试模板001', status: '审核中' },
			],
            usageData: [],
            usageDataCurrentPage: 1,  // 当前页码
            usageDataPageSize: 10,
            usageRecordAmount1: 0,
            usageRecordAmount2: 0,
			storelist: [],
			status: 0,
			form: {
				id: '',
				type: '1',
				upmsg: '',
				downmsg: '',
				imgurl: '',
				qyid: '',
				pageid: '',
				storeid: '',
                couponLimitText1: this.$t('couponLimitText1_text'),
                couponLimitText2: this.$t('couponLimitText2_text'),
                couponLimitText3: this.$t('couponLimitText3_text'),
                isEnable: '1'

			},
			huodonglist: [],
			storeform: {
				storeid: ''
			},
		}
	},
	filters: {
		formatDate: function (time) {
			time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
			let date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		}
	},

	created() {
		var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
		this.qyid = auser.qyid
        this.storeid = auser.storeid
        if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
		this.coupon_read = auser.coupon_read
    	this.coupon_edit = auser.coupon_edit
    	this.exportcsv = auser.exportcsv
		this.gettemplist(auser.storeid)
		this.getpagelist()
		this.gethuodonglist()
		this.getstorelist()
	},
	methods: {
		edititem(data) {
			console.log(data);
			this.form = data
			this.form.tuijian = this.decodeString(data.tuijian)
			this.form.buyurl = this.decodeString(data.buyurl)
            this.form.couponLimitText1 = this.decodeString(data.couponLimitText1)
            this.form.couponLimitText2 = this.decodeString(data.couponLimitText2)
            this.form.couponLimitText3 = this.decodeString(data.couponLimitText3)
			this.dialogVisible = true
		},
        usagerecord(data) {
            let fdata = {
				qyid: this.qyid,
                storeid: data.storeid,
				hdid: data.id
			};
            console.log(data)
			getCouponUsage(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.usageData = res.record
                    this.usageRecordAmount1 = res.sendcount
                    this.usageRecordAmount2 = res.usedcount
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
            this.dialogUsageVisible = true
        },
		beforeHandleCommand(e) {
			console.log(e);
		},
		// 页面切换方法
		handleCurrentChange(val) {
			this.currentPage = val;
		},
        handleUsageDataCurrentChange(val) {
            this.usageDataCurrentPage = val;
        },
		handleClick(tab, event) {
			console.log(tab.index);
			this.status = tab.index
			this.currentPage = 1
			this.gettemplist(this.storeform.storeid)
		},
		handleClose() {
			this.dialogVisible = !this.dialogVisible
		},
        handleUsageClose() {
			this.dialogUsageVisible = !this.dialogUsageVisible
		},
		handlePictureCardPreview() {

		},
		handleRemove() {

		},
		changeStoreid() {
			this.gethuodonglist()
		},
		getstorelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				//qyid: user.id,
				qyid: this.qyid,
                storeid: this.storeid
			};
			getStore(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.storelist = res.data
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
		gethuodonglist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log("user")
			console.log(user)

			let fdata = {
				sjk: 'messenger_huodong_yhq',
				action: 'list',

				//qyid: user.id,
				qyid: this.qyid,
				storeid: this.form.storeid
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.huodonglist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		decodeString(str) {
			if (!str) {
				return str || '';
			}

			return str
				.replace(/\\u[\dA-F]{4}/gi, function (match) {
					return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
				})
				.replace(/\\n/g, '\n');
		},
		encodeString(str) {
			str = str.replace(/\n/g, '\\n');

			return str.split('').map(function (char) {
				const code = char.charCodeAt(0);
				if (code > 127) {
					return '\\u' + code.toString(16).padStart(4, '0');
				}
				return char;
			}).join('');
		},
		// 新增範本点击确定
		sure() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);

			//this.form.qyid = user.id
			this.form.qyid = this.qyid
            if(this.form.tuijian) {
                this.form.tuijian = this.encodeString(this.form.tuijian)
            }
			this.form.buyurl = this.encodeString(this.form.buyurl)

			addHuoDong(this.form).then(res => {
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: res.msg
					})
					this.dialogVisible = false
					this.gettemplist(this.storeform.storeid)
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		//删除某个
		delitem(id) {
			this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

				console.log('del..');
				let fdata = {
					sjk: 'messenger_huodong_yhq',
					action: 'del',
					id: id
				}
				tongyong(fdata).then(res => {
					if (res.code == 1) {
						console.log(res);
						this.gettemplist(this.storeform.storeid)
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			}).catch(_ => {



			})


		},
		changeTableStoreid() {
			console.log('storeid:' + this.storeform.storeid)
			this.gettemplist(this.storeform.storeid)
		},
		// 我的模板列表
		gettemplist(storeid) {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			this.user = user
			let fdata = {
				sjk: 'messenger_huodong_yhq',
				action: 'list',
				// status:this.status,
				// moresearch:'status,',
				//qyid: user.id,
				qyid: this.qyid,
				storeid: storeid
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.tableData = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

		//pagelist 
		getpagelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_pagelist',
				action: 'list',

				//qyid: user.id
				qyid: this.qyid
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.pagelist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

		httpRequest(option) {
			this.fileList.push(option);
		},
		// 上传前处理
		beforeUpload(file) {
			let fileSize = file.size;
			const FIVE_M = 5 * 1024 * 1024;
			//大于5M，不允许上传
			if (fileSize > FIVE_M) {
				this.$message.error(this.$t('max5mb'));
				return false;
			}
			//判断文件类型，必须是xlsx格式
			let fileName = file.name;
			let reg = /^.+(\.png)$/;
			if (!reg.test(fileName)) {
				this.$message.error(this.$t('imageOnly'));
				return false;
			}
			return true;
		},
		// 文件数量过多时提醒
		handleExceed() {
			this.$message({ type: "error", message: this.$t("1attachment") });
		},

		submitImportForm() {
			var user = JSON.parse(window.localStorage.getItem("userinfo"));
			console.log(user);

			if (!this.form.title) {
				this.$message.error(this.$t('pleaseSelect') + " title");
				return
			}
			if (this.fileList.length == 0) {
				this.$message.error(this.$t('pleaseSelect') + " " + this.$t('file'));
				return
			}

			let paramsData = new FormData();
			// 将上传文件数组依次新增到参数paramsData中
			console.log("filelist", this.fileList);

			this.fileList.forEach((x) => {
				console.log(x.file);
				paramsData.append("file", x.file);
			});
			// 将输入表单数据新增到params表单中

			//paramsData.append("qyid", user.id);
			paramsData.append("qyid", this.qyid);
			paramsData.append("title", this.form.title);
			paramsData.append("type", this.form.type);
			paramsData.append("detail", this.form.detail);
			paramsData.append("link", this.form.link);


			//这里根据自己封装的axios来进行调用后端接口
			console.log("paramsData", paramsData.get("file"));

			axios.post("/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_tmp_insert", paramsData).then(res => {
				console.log(res);
			})
			// this.$refs.importFormRef.resetFields()//清除表单信息
			this.$refs.upload.clearFiles()//清空上传列表
			this.fileList = []//集合清空
			this.title = ''
			this.dialogVisible = false//关闭对话框
			this.gettemplist(this.storeform.storeid)

		},
		uploadSectionFile(params) {
			const file = params.file,
				fileType = file.type,
				isImage = fileType.indexOf('image') !== -1,
				isLt2M = file.size / 1024 / 1024 < 2;
			// 这里常规检验，看项目需求而定
			if (!isImage) {
				this.$message.error(this.$t('imageFormatOnly'));
				return;
			}
			if (!isLt2M) {
				this.$message.error(this.$t('imageSizeOnly'));
				return;
			}
			// 根据后台需求数据格式
			const form1 = new FormData();
			// 文件对象
			form1.append('file', file);
			// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
			// form.append("clientType", 'xxx');
			// 项目封装的请求方法，下面做简单介绍


			imageUpload(form1).then(res => {
				//自行处理各种情况
				console.log('res', res)
				this.form.imgurl = res
			}).catch(() => {
				// xxx
			});
		},
		sortChange({ prop, order }) {
			this.tableData.sort(this.compare(prop, order));
		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName]
				var value2 = obj2[propertyName]
				if (typeof value1 === 'string' && typeof value2 === 'string') {
					const res = value1.localeCompare(value2, 'zh')
					return sort === 'ascending' ? res : -res
				} else {
					if (value1 <= value2) {
						return sort === 'ascending' ? -1 : 1
					} else if (value1 > value2) {
						return sort === 'ascending' ? 1 : -1
					}
				}
			}
		}


	}
}
</script>
<style lang="scss" scoped>
.view-dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }
}
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}

.pagination {
	width: 100%;
	margin: 30px auto;
}

::v-deep .el-select {
	width: 100%;

}
</style>